module.exports = __webpack_public_path__ + "img/chat_type1.4e2a287b.png";